<template>
    <div>
        <!-- Banner区域 -->
        <Banner :title="t('banner.title')" :subtitle="t('banner.subtitle')" />

        <!-- 我们的优势板块 -->
        <section class="py-16 bg-white">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="text-center mb-12">
                    <h2 class="text-4xl font-bold mb-4 text-[#005005] border-b-4 border-[#005005] inline-block pb-2">{{ t('home.advantages.title') }}</h2>
                    <p class="text-[#8d6e63] text-lg">{{ t('home.advantages.subtitle') }}</p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    <div class="text-center p-8 bg-gray-50 rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                        <div class="text-4xl text-[#005005] mb-4">
                            <i class="fas fa-leaf"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('home.advantages.items.experience.title') }}</h3>
                        <p class="text-[#212121] leading-relaxed">{{ t('home.advantages.items.experience.description') }}</p>
                    </div>
                    <div class="text-center p-8 bg-gray-50 rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                        <div class="text-4xl text-[#005005] mb-4">
                            <i class="fas fa-flask"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('home.advantages.items.production.title') }}</h3>
                        <p class="text-[#212121] leading-relaxed">{{ t('home.advantages.items.production.description') }}</p>
                    </div>
                    <div class="text-center p-8 bg-gray-50 rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                        <div class="text-4xl text-[#005005] mb-4">
                            <i class="fas fa-recycle"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('home.advantages.items.innovation.title') }}</h3>
                        <p class="text-[#212121] leading-relaxed">{{ t('home.advantages.items.innovation.description') }}</p>
                    </div>
                    <div class="text-center p-8 bg-gray-50 rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                        <div class="text-4xl text-[#005005] mb-4">
                            <i class="fas fa-award"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('home.advantages.items.certification.title') }}</h3>
                        <p class="text-[#212121] leading-relaxed">{{ t('home.advantages.items.certification.description') }}</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 主要产品 -->
        <section class="py-16 bg-gray-50">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="text-center mb-12">
                    <h2 class="text-4xl font-bold mb-4 text-[#005005] border-b-4 border-[#005005] inline-block pb-2">{{ t('home.products.title') }}</h2>
                    <p class="text-[#8d6e63] text-lg">{{ t('home.products.subtitle') }}</p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    <div v-for="product in products" :key="product.titleKey" class="bg-white rounded-xl overflow-hidden shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
                        <div class="h-48 overflow-hidden">
                            <img :src="product.image" :alt="t(product.altKey)" class="w-full h-full object-cover transition-transform duration-300 hover:scale-110">
                        </div>
                        <div class="p-6">
                            <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t(product.titleKey) }}</h3>
                            <p class="text-[#212121] mb-4">{{ t(product.descriptionKey) }}</p>
                            <a :href="product.link" class="inline-block px-6 py-3 bg-[#8d6e63] text-white rounded-lg transition-colors duration-300 hover:bg-[#5f4339]">{{ t('home.products.items.learnMore') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 关于宜宾纸业 -->
        <section class="py-16 bg-white">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div class="pr-8">
                        <div class="text-center lg:text-left mb-8">
                            <h2 class="text-4xl font-bold mb-4 text-[#005005] border-b-4 border-[#005005] inline-block pb-2">{{ t('home.about.title') }}</h2>
                        </div>
                        <p class="text-[#212121] mb-4 leading-relaxed">{{ t('home.about.description1') }}</p>
                        <p class="text-[#212121] mb-4 leading-relaxed">{{ t('home.about.description2') }}</p>
                        <p class="text-[#212121] mb-8 leading-relaxed">{{ t('home.about.description3') }}</p>
                        <a href="/about" class="inline-block px-8 py-4 bg-[#8d6e63] text-white rounded-lg transition-colors duration-300 hover:bg-[#5f4339]">{{ t('home.about.learnMore') }}</a>
                    </div>
                    <div class="rounded-xl overflow-hidden shadow-xl">
                        <img src="/images/23.jfif" alt="宜宾纸业厂区" class="w-full h-full object-cover">
                    </div>
                </div>
            </div>
        </section>

        <!-- 可持续发展 -->
        <section class="py-16 bg-gray-50">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="text-center mb-12">
                    <h2 class="text-4xl font-bold mb-4 text-[#005005] border-b-4 border-[#005005] inline-block pb-2">{{ t('home.sustainability.title') }}</h2>
                    <p class="text-[#8d6e63] text-lg">{{ t('home.sustainability.subtitle') }}</p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div class="flex gap-6 p-8 bg-white rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                        <div class="text-4xl font-bold text-[#005005]/30">01</div>
                        <div>
                            <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('home.sustainability.items.renewable.title') }}</h3>
                            <p class="text-[#212121] leading-relaxed">{{ t('home.sustainability.items.renewable.description') }}</p>
                        </div>
                    </div>
                    <div class="flex gap-6 p-8 bg-white rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                        <div class="text-4xl font-bold text-[#005005]/30">02</div>
                        <div>
                            <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('home.sustainability.items.carbon.title') }}</h3>
                            <p class="text-[#212121] leading-relaxed">{{ t('home.sustainability.items.carbon.description') }}</p>
                        </div>
                    </div>
                    <div class="flex gap-6 p-8 bg-white rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                        <div class="text-4xl font-bold text-[#005005]/30">03</div>
                        <div>
                            <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('home.sustainability.items.clean.title') }}</h3>
                            <p class="text-[#212121] leading-relaxed">{{ t('home.sustainability.items.clean.description') }}</p>
                        </div>
                    </div>
                    <div class="flex gap-6 p-8 bg-white rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                        <div class="text-4xl font-bold text-[#005005]/30">04</div>
                        <div>
                            <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('home.sustainability.items.rural.title') }}</h3>
                            <p class="text-[#212121] leading-relaxed">{{ t('home.sustainability.items.rural.description') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <CTA
          :title="t('home.cta.title')"
          :description="t('home.cta.description')"
          :buttonText="t('home.cta.buttonText')"
          buttonLink="/contact"
          backgroundImage="/images/56.png"
        />
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { onMounted } from 'vue'
import Banner from '../components/Banner.vue'
import CTA from '../components/CTA.vue'

const { t } = useI18n()

const products = [
    {
        image: '/images/mainProduction/BaiSeZhuJiangSuoLve.png',
        altKey: 'home.products.items.bambooPulp.alt',
        titleKey: 'home.products.items.bambooPulp.title',
        descriptionKey: 'home.products.items.bambooPulp.description',
        link: '/products#pulp'
    },
    {
        image: '/images/mainProduction/KeDingZhiShiPinBaoZhuangSuoLveTu.png',
        altKey: 'home.products.items.packagingPaper.alt',
        titleKey: 'home.products.items.packagingPaper.title',
        descriptionKey: 'home.products.items.packagingPaper.description',
        link: '/products#packaging'
    },
    {
        image: '/images/mainProduction/JinZhuA4SuoLve.png',
        altKey: 'home.products.items.culturalPaper.alt',
        titleKey: 'home.products.items.culturalPaper.title',
        descriptionKey: 'home.products.items.culturalPaper.description',
        link: '/products#cultural'
    },
    {
        image: '/images/mainProduction/ShengHuoYuanZhi2SuoLve.png',
        altKey: 'home.products.items.livingPaper.alt',
        titleKey: 'home.products.items.livingPaper.title',
        descriptionKey: 'home.products.items.livingPaper.description',
        link: '/products#rawpaper'
    },
    {
        image: '/images/finishedPaper/QuanXiLieSuoLve.png',
        altKey: 'home.products.items.finishedPaper.alt',
        titleKey: 'home.products.items.finishedPaper.title',
        descriptionKey: 'home.products.items.finishedPaper.description',
        link: '/products#finishedpaper'
    },
    {
        image: '/images/Fibre/SanCuSuanXianWeiSuSuoLve.png',
        altKey: 'home.products.items.fiberMaterial.alt',
        titleKey: 'home.products.items.fiberMaterial.title',
        descriptionKey: 'home.products.items.fiberMaterial.description',
        link: '/products#fiber'
    }
]

onMounted(() => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
})
</script>
